import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowUndoUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowUndoUp"><Path d="M7 5L3 9L7 13" stroke="currentColor" strokeLinecap="square"/><Path d="M4 9H21.5V18.5H12" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowUndoUp;
